export default __webpack_public_path__ + "static/media/keyfob.62881c8d.svg";